import { render, staticRenderFns } from "./createBillingAccount.vue?vue&type=template&id=0afcd041&"
import script from "./createBillingAccount.vue?vue&type=script&lang=ts&"
export * from "./createBillingAccount.vue?vue&type=script&lang=ts&"
import style0 from "./createBillingAccount.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports